import { render, staticRenderFns } from "./KlinePage.vue?vue&type=template&id=9600d510&scoped=true"
import script from "./KlinePage.vue?vue&type=script&lang=js"
export * from "./KlinePage.vue?vue&type=script&lang=js"
import style0 from "./KlinePage.vue?vue&type=style&index=0&id=9600d510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9600d510",
  null
  
)

export default component.exports